import { render, staticRenderFns } from "./ResourcesPage.vue?vue&type=template&id=349b29df&scoped=true"
import script from "./ResourcesPage.vue?vue&type=script&lang=js"
export * from "./ResourcesPage.vue?vue&type=script&lang=js"
import style0 from "./ResourcesPage.vue?vue&type=style&index=0&id=349b29df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b29df",
  null
  
)

export default component.exports